import service from "../service";
import { getApiBaseUrl } from "../config";

export default {
    async getSolutionList(param) {
        const response = await service.get(`${getApiBaseUrl()}solution`, param);
        return response;
    },

    async getSolution(id) {
        const response = await service.get(`${getApiBaseUrl()}solution/${id}`);
        return response;
    },

    async addSolution(solution) {
        const response = await service.post(
            `${getApiBaseUrl()}solution`,
            solution
        );
        return response;
    },

    async updateSolution(solution) {
        const response = await service.patch(
            `${getApiBaseUrl()}solution`,
            solution
        );
        return response;
    },

    async deleteSolution(solution_id) {
        const response = await service.delete(
            `${getApiBaseUrl()}solution/${solution_id}`
        );
        return response;
    },
};
